import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import AllBrands from "../components/Brands/AllBrands"

const Brands = () => {
  return (
    <Layout>
      <SEO title="All Brands"/>
      <AllBrands/>
    </Layout>

  )
}

export default Brands
